import React from "react";
import ReactDOM from "react-dom";
import ContactUsCenter from "../components/contact-us/ContactUsCenter";
import { initializeI18n } from "../localization/i18n";

// Expose render function globally for the Umbraco Razor view.
window.renderContactUsCenter = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (element) {
    // Translations come from the i18n backend (common_ns); components carry English
    // fallbacks inline, so render even if i18n initialization fails.
    initializeI18n()
      .then(() => {
        ReactDOM.render(<ContactUsCenter props={props} />, element);
      })
      .catch(() => {
        ReactDOM.render(<ContactUsCenter props={props} />, element);
      });
  }
};
